<template>
  <div class="subproperty-list-page app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.subproperty.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-create">
      <!-- Filter button -->
      <app-filter-button
        :active.sync="activeFilter"
        v-if="allRows && allRows.length > 0"
      />

      <router-link
        v-if="hasPermissionToCreate"
        :to="{ path: '/subproperty/new' }"
      >
        <el-button
          class="app-content-create-button"
          type="primary"
        >
          <app-i18n :code="!isPropertyNBA ? 'entities.subproperty.new.button' : 'entities.base.new.title'" />
        </el-button>
      </router-link>
    </div>

    <app-subproperty-list-filter
      v-if="activeFilter"
    />

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.subproperty.list.title"></app-i18n>
      </h1>

      <app-subproperty-list-toolbar></app-subproperty-list-toolbar>
      <app-subproperty-list-filter></app-subproperty-list-filter>
      <app-subproperty-list-table></app-subproperty-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { SubpropertyPermissions } from '@modules/subproperty/subproperty-permissions';
import SubpropertyListFilter from '@modules/subproperty/components/subproperty-list-filter.vue';
import SubpropertyListTable from '@modules/subproperty/components/subproperty-list-table.vue';
import SubpropertyListToolbar from '@modules/subproperty/components/subproperty-list-toolbar.vue';

export default {
  name: 'app-subproperty-list-page',
  data() {
    return {
      activeFilter: false,
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
      allRows: 'subproperty/list/rows',
    }),
    hasPermissionToCreate() {
      return new SubpropertyPermissions(this.currentUser).create;
    },
  },
  components: {
    [SubpropertyListFilter.name]: SubpropertyListFilter,
    [SubpropertyListTable.name]: SubpropertyListTable,
    [SubpropertyListToolbar.name]: SubpropertyListToolbar,
  },
};
</script>

<style scoped>

/* .subproperty-list-page .filter {
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 0;

  padding-top: 2em;
  margin-top: 2em;
  border-top: 1px solid #eaeaea;
}

.subproperty-list-page .app-content-create .app-content-create-filter {
  border: none;
  margin-right: 1em;
  color: initial;
}.subproperty-list-page .app-content-create .app-content-create-filter:focus,
.subproperty-list-page .app-content-create .app-content-create-filter:hover {
  color: #2ACCCC;
}


.subproperty-list-page .app-content-create .app-content-create-filter span {
  padding-left: 8px;
} */

</style>
